module.exports = __webpack_public_path__ + "static/img/jainjie.1e1cb480.jpg";